import { render, staticRenderFns } from "./kickOut.vue?vue&type=template&id=3d0c0de2&"
import script from "./kickOut.vue?vue&type=script&lang=js&"
export * from "./kickOut.vue?vue&type=script&lang=js&"
import style0 from "./kickOut.vue?vue&type=style&index=0&id=3d0c0de2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports